module.exports = __webpack_public_path__ + "images/FUSA_icons/090-shopping-basket.e4b59d36356c1d2b86a0339e8caf6c46.svg";